import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";

export default class BadRequestException extends Error {
    constructor(message: string) {
        super(message);
        DiagnosticsStore.collectEventLog("error", `[API] ${message}`);
    }
}
